import { keyframes, styled } from '@mui/material/styles'
import { Box, Divider, IconButton, Paper, Typography } from '@mui/material'
import { MEDIA } from '../../constants'

export const OuterWrapper = styled(Paper)(`
  padding: 0 12px;
  width: 100vw;
  height: 100vh;
  position:fixed;
  display:flex;
  flex-direction:column;
  top:0;
  left:0;
  z-index: 50;
  @media (max-width: ${MEDIA.lg}) {
    padding: 0 12px;
  }
  
  & .footerWrapper {
    height: 40px;
    background: transparent;
  }
`)

export const InnerWrapper = styled(Paper)(({ theme }) => `
  height: calc(100% - 75px);
  border-radius: 24px;
  overflow: hidden;
  width: 100%;
  position: relative;
  background: ${theme.palette.background.secondary} !important;
`)

export const IconCloseOuterWrapper = styled(Box)(`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  min-height: 40px;
  padding: 0 16px;
`)

export const HeaderRightSection = styled(Box)(({ theme }) => `
  display: flex;
  align-items: center;
  & .button-back {
    border-radius: 4px;
    height: 28px;
    font-weight: 400;
    background: transparent;
    color: ${theme.palette.mode === 'dark' ? '#7C868F' : '#000'};
  }
`)

export const HeaderLeftSection = styled(Box)(({ theme }) => `
  display: flex;
  alignItems: center;
  gap: 8px;
  & .brand-name {
    fontSize: 16px;
    fontWeight: 600;
    color: ${theme.palette.text.primaryTemp};
  }
  & .project-type {
    fontSize: 13px;
    fontWeight: 400;
    color: ${theme.palette.text.primaryTemp};
  }
  & .sub-title {
    color: ${theme.palette.success.main};
    fontSize: 14px;
    fontWeight: 600;
  }
`)

export const Logo = styled(Box)(`
  display: flex;
  align-items: center;
  & img {
    height: 16px;
  }
`)
